import { OptionalSystem, BaseSystem } from "../../../../types/optionalSystems";

// Structure Systems
export function isStructureSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "structure";
}

// Modular Hull Systems
export function isModularHullSystemGuard(
  system: OptionalSystem,
): system is any {
  return (system as BaseSystem).type === "modularHull";
}

// Power Systems
export function isPowerSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "power";
}

// Drive Systems
export function isDriveSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "drive";
}

// Fuel Systems
export function isFuelSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "fuel";
}

// Accommodation Systems
export function isAccommodationSystemGuard(
  system: OptionalSystem,
): system is any {
  return (system as BaseSystem).type === "accommodation";
}

// Bridge Systems
export function isBridgeSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "bridge";
}

// Cargo Systems
export function isCargoSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "cargo";
}

// Drone Systems
export function isDroneSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "drone";
}

// Sensor Systems
export function isSensorSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "sensor";
}

// External Systems
export function isExternalSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "external";
}

// Internal Systems
export function isInternalSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "internal";
}

// Legacy type guards for backward compatibility
export function isHangarSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "hangar";
}

export function isArmorySystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "armory";
}

export function isEscapePodSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "escapePod";
}

export function isFuelProcessorSystemGuard(
  system: OptionalSystem,
): system is any {
  return (system as BaseSystem).type === "fuelProcessor";
}

export function isFuelScoopSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "fuelScoop";
}

export function isFuelTankSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "fuelTank";
}

export function isJumpDriveSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "jumpDrive";
}

export function isManeuverDriveSystemGuard(
  system: OptionalSystem,
): system is any {
  return (system as BaseSystem).type === "maneuverDrive";
}

export function isPowerPlantSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "powerPlant";
}

export function isShieldSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "shield";
}

export function isTurretSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "turret";
}

export function isWeaponSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "weapon";
}

export function isSmallCraftSystemGuard(system: OptionalSystem): system is any {
  return (system as BaseSystem).type === "smallCraft";
}
